export interface CatalogSection {
	SectionId: number | null;
	SectionName: string;
	IsActive: boolean;
	CreatedBy: string | null;
	CreatedDate: Date | null;
	ModifiedBy: string | null;
	ModifiedDate: Date | null;
}

export const CATALOG_SECTION_INITIAL_VALUES: CatalogSection = {
	SectionId: null,
	SectionName: "",
	IsActive: true,
	CreatedBy: null,
	CreatedDate: null,
	ModifiedBy: null,
	ModifiedDate: null,
};
